import { Entry } from '../Entry'

export function Entry20220311() {
  return (
    <Entry title="11/03/2022 - v3.0.0-beta-17.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12413/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
